import './trello-client.js'

/* ================================ Actions ================================= */

function trello_onload({ commit }) {
  console.log("trello_onload");

  let token;
  let storage = window.localStorage;
  if (storage != null) {
    token = storage["trello_token"];

    let authdate = storage["trello_authdate"];
    commit("TRELLO_AUTH_DATE", authdate);
  }

  if ( window.Trello.authorized() ) {

    console.log("trello_onload: trello already authorized");
    commit("TRELLO_AUTHORIZED", 1);

  } else {

    console.log("trello_onload: we have to authorize or user is not connected");

    if ( token ) {
      trello_auth( { commit }, false );
    } else {
      commit("TRELLO_AUTHORIZED", 0);
    }
  }
}

function trello_auth({ commit }, connectButton) {

  // if ( window.Trello.authorized() ) {
  //   console.log("already authorized");
  //   commit("TRELLO_AUTHORIZED", 1);
  //   return
  // } else {
  //   console.log("we have to authorize");
  // }

  function onTrelloAuthSuccess() {
    console.log("trello_auth: success");
    commit("TRELLO_AUTHORIZED", 1);
  }

  function onTrelloAuthError(e) {
    console.log("trello_auth: error", e);
    commit("TRELLO_AUTHORIZED", -1);
  }

  window.Trello.authorize({
    type: 'popup',
    name: 'Goalpilot',
    persist: true,
    expiration: '30days',
    success: onTrelloAuthSuccess,
    error: onTrelloAuthError
  })
}

function trello_unauth({ commit }) {
  window.Trello.deauthorize();

  if ( window.localStorage["trello_token"] === undefined ) {
    commit("TRELLO_AUTHORIZED", 0);
    commit("TRELLO_AUTH_DATE", null);
  }
}

// -----------------------------------------------------------------------------

export default {
  trello_onload,
  trello_auth,
  trello_unauth
};
